// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c4e9c4d864cd030f","5371":"506a9e6e6e4b4e4c"}[chunkId] + ".css";
};